import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import REGEXP from 'constant/REGEXP'

const validate = values => {
    const errors = {}
    if (!values.email) errors.email = 'Your email?'
    else if (!REGEXP.validations.email.test(values.email)) errors.email = 'Invalid format.'
    if (!values.password) errors.password = 'Need a password.'
    return errors
}

class LoginForm extends Component {
    render() {
        const { handleSubmit, pristine, submitting, error } = this.props
        return (
            <form onSubmit={ handleSubmit } className='form-horizontal m-t-10'>
                <Field name='email' component={ InputField } type='email' placeholder='Email...'/>
                <Field name='password' component={ InputField } type='password' placeholder='Password...'/>
                <div className='form-group text-center m-t-30'>
                    <div className='col-xs-12'>
                        <button className='btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase' type='submit' disabled={ pristine || submitting }>Log In</button>
                    </div>
                </div>
                {
                    error ? <p className='error' id='login-error'>{ error }</p> : null
                }
            </form>
        )
    }
}

LoginForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

export default LoginForm = reduxForm({
    form: 'login',
    validate
})(LoginForm)


// WEBPACK FOOTER //
// ./src/client/features/session/components/LoginForm.jsx